import { defineReceiver, defineCommand } from '@drapejs/invoker';
import { request, query } from '@distancify/drapejs-litium';
import { gql } from 'graphql-request';

export const commands = {
  performQuickSearch: defineCommand<{
    url: string;
    categorySystemId: string;
    take: number;
    sort: string;
    searchPhrase: string;
    /**
     * The cache key to store the category data in
     */
    cacheKey?: string;
  }>('performQuickSearch'),
};

export const receivers = {
  performQuickSearch: defineReceiver(
    commands.performQuickSearch,
    async function (command, data) {
      const result = await request(
        this.cache,
        query(gql`
          query performQuickSearch(
            $url: String!
            $rootCategory: String!
            $take: Int!
            $sort: String!
            $searchPhrase: String!
          ) {
            session(url: $url) {
              productSearchV2(
                rootCategory: $rootCategory
                take: $take
                sort: $sort
                searchPhrase: $searchPhrase
              ) {
                hits
                facetSuggestions {
                  field
                  suggestedValues {
                    value
                    label
                  }
                }
                products {
                  articleNumber
                  productName
                  url
                  price
                  campaignPrice
                  campaignName
                  image
                  variants {
                    articleNumber: id
                  }
                  googleAnalyticsName
                  imageIds
                  colorCode
                  allColorCodes
                  colorOptions {
                        url
                        imageId
                        colorCode
                        sizes {
                            caption
                            inStock
                        }
                    }
                  sizes {
                    caption
                    inStock
                  }
                  productCardTag {
                    name
                    value
                  }
                }
              }
              pageSearch(take: $take, searchPhrase: $searchPhrase) {
                take
                hits
                totalHits
                searchPhrase
                pages {
                  pageName
                  url
                }
              }
              categorySearch(take: $take, searchPhrase: $searchPhrase) {
                hits
                categories {
                  fields
                  url
                  departmentName
                }
              }
            }
          }
        `),
        {
          url: `${(<any>command).protocol}//${(<any>command).host}${(<any>command).path}`,
          rootCategory: command.categorySystemId,
          take: command.take,
          sort: (<any>command).query?.sort || 'relevance',
          searchPhrase: decodeURIComponent((<any>command).query.search || '')
        }
      );

      return result.session;
    },
    'litium'
  ),
};
